import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../components/atoms/Button";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";

export default function AdminLogin() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const location = useLocation(); // ← ini yang kurang

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Login Admin:", formData);

    // TODO: lakukan API login dulu
    // Jika success → redirect ke OTP
    const currentLang = location.pathname.startsWith("/id") ? "id" : "en";

    navigate(
      `/${currentLang}/login/admin/otp-verification?email=${encodeURIComponent(
        formData.email
      )}`
    );
  };

  return (
    <MainLayoutDetail>
      <div className="container-section mx-auto mt-32 px-6">
        <SectionBox
          titleClassName="text-2xl md:text-3xl text-white"
          background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)"
        >
          <div className="flex items-center justify-center">
            <form
              onSubmit={handleSubmit}
              className="bg-white p-4 md:p-8 rounded-2xl shadow-md w-96"
            >
              <h2 className="text-2xl font-semibold mb-6 text-gray-800 text-center">
                Admin HR Login
              </h2>

              <div className="flex flex-col gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />

                <Button type="submit" className="w-full bg-primary hover:bg-secondary">
                  Login
                </Button>
              </div>
            </form>
          </div>
        </SectionBox>
      </div>
    </MainLayoutDetail>
  );
}
